<template>
  <footer>
   <nav>
      <!-- <ul>
        <li>
          <a
            href="https://causalanalysis.ai/"
            target="_blank"
            rel="noopener noreferrer"
            >Contact</a
          >
        </li>
        <li>
          <a
            href="https://causalanalysis.ai/"
            target="_blank"
            rel="noopener noreferrer"
            >Privacy</a
          >
        </li>
        <li>
          <a
            href="https://causalanalysis.ai/"
            target="_blank"
            rel="noopener noreferrer"
            >Terms of use</a
          >
        </li>
        <li>
          <a
            href="https://causalanalysis.ai/"
            target="_blank"
            rel="noopener noreferrer"
            >Accessibility</a
          >
        </li>
        <li>
          <a
            href="https://causalanalysis.ai/"
            target="_blank"
            rel="noopener noreferrer"
            >Cookie preferences</a
          >
        </li>
      </ul> -->
      <p>&copy; 2025 hootfolio Co., Ltd.</p>
      <!-- <div></div> -->
    </nav>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
<style scoped lang="scss">
footer {
  flex-shrink: 0;
  padding: 10px;

  nav {
    display: flex;
    justify-content: center;
    align-items: center; 
    height: 1rem;
  }

  nav p {
    color: lighten($text-dark, $emphasis-medium);
    font-size: 14px;
    margin: 0; 
  }

  nav a {
    color: lighten($text-dark, $emphasis-medium);
  }
}
</style>